import { render, staticRenderFns } from "./tasks-tab.vue?vue&type=template&id=697bb87c&"
import script from "./tasks-tab.vue?vue&type=script&lang=js&"
export * from "./tasks-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports